<template>
  <div>
    <el-row class="cs-search-conditions">
      <el-col :span="4">
        <el-input placeholder="按号码搜索" size="medium" :disabled="loading" class="sc-phone" clearable suffix-icon="el-icon-search" v-model.trim="searchCondition.phone"
          @change="onPhoneChange" />
      </el-col>
      <el-col :span="4">
        <el-select class="margin-left-20px" placeholder="课程类型" size="medium" :disabled="loading" v-model="searchCondition.courseType" @change="onCourseTypeChange">
          <el-option v-for="item in scPreloadData.courseTypeItems" :key="item.value" :label="item.desc" :value="item.value" />
        </el-select>
      </el-col>
      <div class="cs-content-group" v-if="searchCondition.courseType === GLOBAL.courseType.university">
        <el-col :span="4">
          <el-select class="margin-left-20px" placeholder="学校" size="medium" :disabled="loading" v-model="searchCondition.groupNumber" @change="onGroupNumberChange">
            <el-option v-for="item in scPreloadData.universityGroups" :key="item.IdValue" :label="item.NameValue" :value="item.GroupNumber" />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select class="margin-left-20px" placeholder="学期" size="medium" :disabled="loading" v-model="searchCondition.termId" @change="onTermIdChange">
            <el-option v-for="item in scPreloadData.termList" :key="item.Id" :label="item.DisplayLable" :value="item.Id" />
          </el-select>
        </el-col>
      </div>
      <div class="cs-content-group" v-if="searchCondition.courseType === GLOBAL.courseType.vocationalTraining">
        <el-col :span="4">
          <el-select class="margin-left-20px" placeholder="职业类型" size="medium" :disabled="loading" v-model="searchCondition.trainingCourseCategory" @change="onTrainingCourseCategoryChange">
            <el-option v-for="item in scPreloadData.trainingCourseCategories" :key="item.Id" :label="item.Name" :value="item.Id" />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select class="margin-left-20px" placeholder="学期" size="medium" :disabled="loading" v-model="searchCondition.trainingTermId" @change="onTrainingTermIdChange">
            <el-option v-for="item in trainingTermList" :key="item.Id" :label="item.DisplayLable" :value="item.Id" />
          </el-select>
        </el-col>
      </div>

      <el-col :span="4" class="padding-left-20px">
        <el-checkbox size="medium" :disabled="loading" v-model="searchCondition.isVideoCourseRemoved" class="cs-isVideoCourseRemoved" @change="onisVideoCourseRemovedChange">去除视频课</el-checkbox>
      </el-col>
      <el-col :span="4" class="cs-signInQuery-buttons">
         <el-button type="primary" :disabled="loading" size="medium" @click="onSearch">搜索</el-button>
      </el-col>
    </el-row>

    <pagination v-loading="loading" :data="signInListData" :option="paginationOption" />

    <el-row class="">
    <br/>
    1. 该查询用来查阅大学课程的总出勤率或单个学生的出勤率<br/>
    2. 用途：<br/>
        a. 教务总监查看每个课程的出勤率<br/>
        b. 销售人员查看单个学生的出勤，处理退款<br/>
    3. 计算规则：<br/>
        a. 默认：出勤率 = 签到人数 / 总人数减去缺课人数<br/>
        b. 选择"去除视频课": 出勤率 = 签到人数 / 总人数减去缺课和视频课人数。若全部学生为视频课，则显示N/A

    </el-row>
  </div>
</template>

<script>
import pagination from "@/components/common/pagination";

import { downloadFile } from "@/config/mUtils";
import { getTrainingTerms } from "@/service/common.service";
import {
  getSignInQueryListByStudent,
  exportSignInQueryListByStudent,
} from "@/service/signInManage.service";

const defaultValues = {
  signInListData: {
    Columns: [],
    Results: [],
  },
};

import { mixinSignInQuery } from "./mixinSignInQuery";
export default {
  name: "signInQueryList1",
  mixins: [mixinSignInQuery],
  components: {
    pagination,
  },
  props: {
    colOptions: {
      type: Object,
    },
    queryType: {
      type: String,
      required: true,
    },
    scPreloadData: {
      type: Object,
      default: () => {
        return {
          defaultValues: {},
          termList: [],
          universityGroups: [],
          trainingCourseCategories: [],
        };
      },
    },
    paginationOption: {
      typeof: Object,
      default: () => {
        return {
          displayPagination: false,
          hasEditButton: false,
          editButtonText: String.empty,
          hasAddButton: false,
          addButtonText: String.empty,
          hasSearch: false,
          editColumnTite: String.empty,
          showAcitveColor: true,
          hideDisableRow: true,
          displayCampus: this.searchCondition.courseType === this.GLOBAL.courseType.vocationalTraining,
        };
      },
    },
  },
  data() {
    return {
      loading: false,
      isDataReady: false,
      isSaveStudentCourseAttendanceHistoryForAll: false,
      searchCondition: {
        courseType: null,
        groupNumber: null,
        termId: null,
        trainingCourseCategory: null,
        trainingTermId: null,
        phone: null,
        isVideoCourseRemoved: false,
      },
      trainingTermList: [],
      signInListData: defaultValues.signInListData,
    };
  },
  created() {
    this.searchCondition.courseType = 1;
  },
  computed: {
    canExport() {
      if (this.queryType !== "1" || !this.isDataReady) return false;

      if (
        this.searchCondition.courseType ===
          this.GLOBAL.courseType.vocationalTraining &&
        this.signInListData.Results.length === 0
      )
        return false;

      if (this.signInListData.Results.length === 0) return false;

      return true;
    },
  },
  methods: {
    async loadTrainingTermsFromServer() {
       
      if (
        this.queryType !== "1" ||
        this.searchCondition.courseType !==
          this.GLOBAL.courseType.vocationalTraining
      )
        return;

      let result = await getTrainingTerms(
        false,
        this.searchCondition.trainingCourseCategory
      );
      this.trainingTermList = !!result && result.success ? result.data : [];
      if (this.searchCondition._fromStore) return;

      let currentTerm = null;
      if (this.trainingTermList.length > 0) {
        currentTerm = this.trainingTermList.find((i) => i.IsCurrentTerm);
        if (!currentTerm) currentTerm = this.trainingTermList[0];
      }
      this.searchCondition.trainingTermId = !!currentTerm
        ? currentTerm.Id
        : null;
    },
    async loadSignInQueryListByStudentFromServer() {
      if (this.queryType !== "1") return;

      let termId =
        this.searchCondition.courseType ===
        this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.trainingTermId
          : this.searchCondition.termId;
      let groupNumber = this.searchCondition.groupNumber;
      let courseCategory = this.searchCondition.trainingCourseCategory;

      let checkResult1 =
        this.searchCondition.courseType ===
          this.GLOBAL.courseType.vocationalTraining &&
        !this.searchCondition.trainingCourseCategory;
      let checkResult2 =
        this.searchCondition.courseType === this.GLOBAL.courseType.university &&
        !this.searchCondition.groupNumber;
      if (!termId || checkResult1 || checkResult2) {
        this.signInListData = defaultValues.signInListData;
        return;
      }

      this.loading = true;
      let result = await getSignInQueryListByStudent(
        this.searchCondition.courseType,
        termId,
        this.searchCondition.groupNumber,
        this.searchCondition.trainingCourseCategory,
        this.searchCondition.phone,
        this.searchCondition.isVideoCourseRemoved
      );
      this.paginationOption.displayCampus = this.searchCondition.courseType === this.GLOBAL.courseType.vocationalTraining;
      this.signInListData =
        !!result && result.success ? result.data : defaultValues.signInListData;
      this.updateSignInQueryAll({
        queryType: this.queryType,
        searchCondition: this.searchCondition
      });
      this.$set(this.searchCondition, "_fromStore", false);
      this.loading = false;
    },
    async exportSignInQueryListFromServer() {
      if (this.queryType !== "1") return;

      let termId =
        this.searchCondition.courseType ===
        this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.trainingTermId
          : this.searchCondition.termId;

      let checkResult1 =
        this.searchCondition.courseType ===
          this.GLOBAL.courseType.vocationalTraining &&
        !this.searchCondition.trainingCourseCategory;
      let checkResult2 =
        this.searchCondition.courseType === this.GLOBAL.courseType.university &&
        !this.searchCondition.groupNumber;
      if (!termId || checkResult1 || checkResult2) {
        this.signInListData = defaultValues.signInListData;
        return;
      }

      this.loading = true;
      let result = await exportSignInQueryListByStudent(
        this.searchCondition.courseType,
        termId,
        this.searchCondition.groupNumber,
        this.searchCondition.trainingCourseCategory,
        this.searchCondition.phone,
        this.searchCondition.isVideoCourseRemoved
      );
      if (!!result && result.success) {
        downloadFile(result);
      }

      this.loading = false;
    },
    onCourseTypeChange() {
      this.$nextTick(async () => {
        await this.loadTrainingTermsFromServer();
      });
    },
    onGroupNumberChange() {
    },
    onTermIdChange() {
    },
    onTrainingCourseCategoryChange() {
      this.$nextTick(async () => {
        await this.loadTrainingTermsFromServer();
      });
    },
    onTrainingTermIdChange() {
    },
    onPhoneChange() {
    },
    onisVideoCourseRemovedChange() {
    },
    getSearchCondition(){
      return this.searchCondition;
    },
    onSearch(){
       this.$nextTick(async () => {

        await this.loadSignInQueryListByStudentFromServer();
      });
    }
  },
  watch: {
    queryType(newValue, oldValue) {
      if (newValue == "1") {
        if (this.isDataReady) {
          this.updateSignInQueryAll({
            queryType: newValue,
            searchCondition: this.searchCondition,
          });
          return;
        } else {
          this.updateQueryType(newValue);
        }
      } else {
        return;
      }

      this.$nextTick(async () => {
        let storeSearchConditionValue = this.storeSearchCondition;
        if (!!storeSearchConditionValue) {
          this.searchCondition = storeSearchConditionValue;
          this.$set(this.searchCondition, "_fromStore", true);
        }

        await this.loadTrainingTermsFromServer();
        await this.loadSignInQueryListByStudentFromServer();
        this.isDataReady = true;
      });
    },
    scPreloadData(newValue, oldValue) {
      Object.copy(
        this.searchCondition,
        { onlyFieldExists: true },
        newValue.defaultValues
      );

      if (this.queryType != "1") return;

      this.$nextTick(async () => {
        let storeSearchConditionValue = this.storeSearchCondition;
        if (!!storeSearchConditionValue) {
          this.searchCondition = storeSearchConditionValue;
          this.$set(this.searchCondition, "_fromStore", true);
        }

        await this.loadTrainingTermsFromServer();
        await this.loadSignInQueryListByStudentFromServer();
        this.isDataReady = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-search-conditions {
  .el-col {
    padding-top: 5px;
    padding-bottom: 5px;
  }
}

.cs-isVideoCourseRemoved {
  line-height: 36px;
  margin-bottom: 0;
  margin-left: 5px;
}

.cs-signInQuery-buttons {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/signInManage/signInQueryList1.vue